<ng-container *ngIf="isSlider; else scroller">
  <nav class="productDiscover__container">
    <div class="productDiscover__slider" (scroll)="onScroll()" #slider>
      <div class="productDiscover__item" *ngFor="let product of products; let i = index">
        <vc-catalog-snippet
          [index]="i"
          [likedItem]="likedItem"
          [product]="product"
          [seoContext]="seoContext"
          [eventToObserve]="eventClick"
          [isArrangement]="true"
          (click)="onProductClick(product, i)"
        ></vc-catalog-snippet>
      </div>
      <ng-container *ngIf="isMdUp && products.length > itemMin">
        <button
          class="mainControl mainControl--mainPrev"
          [ngClass]="{'mainControl--clickable': prevClickable}"
          (click)="scrollToPrev(slider)"
          aria-hidden="true"
          tabindex="-1"
          [disabled]="!prevClickable"
        >
          <vc-sprite-icons name="arrow-head-left-thick"></vc-sprite-icons>
        </button>
        <button
          class="mainControl mainControl--mainNext"
          [ngClass]="{'mainControl--clickable': nextClickable}"
          (click)="scrollToNext(slider)"
          aria-hidden="true"
          tabindex="-1"
          [disabled]="!nextClickable"
        >
          <vc-sprite-icons name="arrow-head-left-thick"></vc-sprite-icons>
        </button>
      </ng-container>
    </div>
  </nav>
</ng-container>

<!-- scroller display -->
<ng-template #scroller>
  <nav class="productDiscover__scroller">
    <div class="productDiscover__item" *ngFor="let product of products; let i = index">
      <vc-catalog-snippet
        class="productDiscover__item__snippet"
        [index]="i"
        [likedItem]="likedItem"
        [product]="product"
        [seoContext]="seoContext"
        [eventToObserve]="eventClick"
        [isArrangement]="true"
      ></vc-catalog-snippet>
    </div>
  </nav>
</ng-template>
